import { ApolloClient, InMemoryCache } from '@apollo/client';
import env from 'day4-utils/es/env';

const client = new ApolloClient({
  uri: env.DAY4_APP_GALLERY_API,
  cache: new InMemoryCache(),
});

export default client;
